/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import ErrorView from './views/ErrorView';
import LoadingView from './views/LoadingView';
import MainView from './views/MainView';
import MarkAsClosedButton from './buttons/MarkAsClosedButton';
import TicketNotFoundView from './views/TicketNotFoundView';
import Track from '../utils/ZorseGrrTaggingTracker';
import { loadTicket } from '../actions/TicketActions';
import { loadTicketExternalProperties } from '../actions/TicketExternalPropertiesActions';
import { useAppDispatch, useAppSelector } from '../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PanelBody({
  actionStates,
  isResolutionDisabled
}) {
  if (actionStates.hasErroredLoading) {
    return /*#__PURE__*/_jsx(ErrorView, {});
  } else if (actionStates.couldNotFindTicket) {
    return /*#__PURE__*/_jsx(TicketNotFoundView, {});
  } else if (actionStates.isLoading) {
    return /*#__PURE__*/_jsx(LoadingView, {});
  } else {
    return /*#__PURE__*/_jsx(MainView, {
      isCloseTicketDisabled: isResolutionDisabled
    });
  }
}
function ZorseGrrTaggingPanel(props) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    Track.conversationId = props.conversationId;
    Track.openPanel();
    return () => Track.closePanel();
  }, [props.conversationId]);
  useEffect(() => {
    dispatch(loadTicketExternalProperties());
    dispatch(loadTicket(props.conversationId));
  }, [dispatch, props.conversationId]);
  const actionStates = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates);
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: 320,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "dialog-close-test-id",
      className: "m-right-3",
      onClick: props.onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `app.panel.header.title.${props.isResolutionDisabled ? 'update' : 'resolve'}`
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      className: "panel-body",
      children: /*#__PURE__*/_jsx(PanelBody, {
        actionStates: actionStates,
        isResolutionDisabled: props.isResolutionDisabled
      })
    }), /*#__PURE__*/_jsx(UIPanelFooter, {
      className: "panel-footer",
      children: props.isResolutionDisabled ? /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "done-test-id",
        onClick: props.onClose,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.panel.footer.buttons.done"
        })
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MarkAsClosedButton, {
          onResolved: props.onResolved
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: props.onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.panel.footer.buttons.cancel"
          })
        })]
      })
    })]
  });
}
ZorseGrrTaggingPanel.propTypes = {
  isResolutionDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  conversationId: PropTypes.number.isRequired,
  onResolved: PropTypes.func.isRequired
};
ZorseGrrTaggingPanel.defaultProps = {
  isResolutionDisabled: false
};
export default ZorseGrrTaggingPanel;